/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class ShiftPlanService {
  /**
   * 👤 Get the next upcoming shift for the authenticated user
   * @returns any OK
   * @throws ApiError
   */
  public static getUpcomingShift(): CancelablePromise<{
    data:
      | {
          /**
           * Shift ID
           */
          id?: number
          /**
           * Shift start date in ISO 8601 format
           */
          startDate?: string
          /**
           * Shift end date in ISO 8601 format
           */
          endDate?: string
          /**
           * Duration of the shift in hours
           */
          durationInHours?: number
          /**
           * Name of the shift
           */
          name?: string | null
          /**
           * Color associated with the shift
           */
          color?: string | null
          /**
           * Description of the shift
           */
          description?: string | null
          /**
           * Attachments related to the shift
           */
          attachments?: Array<{
            /**
             * filename
             */
            name: string
            /**
             * url of the file
             */
            url: string
          }>
          /**
           * Employees assigned to this shift
           */
          employees?: Array<{
            /**
             * Shift employee ID
             */
            id?: number
            /**
             * Employee ID
             */
            employeeId?: number
            /**
             * Employee name
             */
            name?: string
          }>
          /**
           * Maximum number of employees assignable to this shift
           */
          maxEmployees?: number
          /**
           * Fields that have changed from previous revision
           */
          changedFields?: Array<string>
          /**
           * Shift place ID
           */
          placeId?: number
          /**
           * Shift place name
           */
          placeName?: string
          /**
           * Shift plan revision ID
           */
          revisionId?: number
          /**
           * Shift plan container ID
           */
          planId?: number
          /**
           * Shift plan name
           */
          planName?: string | null
          /**
           * Shift plan description
           */
          planDescription?: string | null
          /**
           * Plan attachments
           */
          planAttachments?: Array<Record<string, any>>
        }
      | any[]
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/shift-plan/next',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 👤 Get all upcoming shifts for the authenticated user
   * @returns any OK
   * @throws ApiError
   */
  public static getUpcomingShifts(): CancelablePromise<{
    data: any[]
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/shift-plan/all',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
}
